import React from 'react';
import './style.css';
import LoginComponent from '../login/index';
import users from '../../services/users'
import LoadingComponent from '../../components/loading/index';
import InitialConfigComponent from '../initial-config/index';
import MainPage from '../main-page/index';
import {withRouter} from 'react-router-dom';

export default withRouter(class Root extends React.Component {
    state = {
        loading: true,
        firstTime: false,
        loggedin: false,
        user: null,
        validation: false
    }

    async componentWillMount() {
        this.props.history.push("/")
        users.getValidation((error, validation) => {
            if(!validation)
                this.setState({loading: false, firstTime: true, validation: validation})
            else
                this.setState({loading: false, firstTime: false, validation: validation})
        })
    }

    login = (user) => {
        this.setState({user: user, loggedin: true})
    }

    logout = () => {
        this.props.history.push("/")
        this.setState({user: null, loggedin: false})
    }

    register = (user) => {
        this.setState({firstTime: false, user: user, loggedin: true, validation: true})
    }

    updateUser = (user) => {
        this.setState({user: user})
    }

    render() {
        if(this.state.loading)
            return <LoadingComponent />

        if(this.state.firstTime && !this.props.command)
            return <InitialConfigComponent {...this.props} register={this.register} />

        if(!this.state.loggedin)
            return <LoginComponent validation={this.state.validation} login={this.login} />;
        else
            return (
                <MainPage updateUser={this.updateUser}
                    logout={this.logout}
                    user={this.state.user}
                />
            )
    }
})


// WEBPACK FOOTER //
// ./src/scenes/root/index.js